import WorkflowElement from "../element"

export default class Start extends WorkflowElement {
  static get elementName() {
    return "workflow-start"
  }

  compute() {
    // noop
  }
}

customElements.get("workflow-start") ||
  customElements.define("workflow-start", Start)
